﻿/*
 * File per la definizione delle direttive Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/directive
 */
define([
    'angular'
],
    function (angular) {
        var inputDirectives = angular.module('inputDirectives', []);

        inputDirectives.directive('smartCodfisc', ['$filter', '$log', 'CFService', SmartCodfisc]);
        inputDirectives.directive('smartIsCodFisEnte', ['$q', 'ResourceService', 'CFService', smartIsCodFisEnte ] );
        inputDirectives.directive('smartDate', ['$filter', '$log', SmartDate]);
        inputDirectives.directive('capitalize', ['CONSTANTS', Capitalize]);
        inputDirectives.directive('datepicker', ['CONSTANTS', Datepicker]);

        /* unused */ function smartIsCodFisEnte( $q, ResourceService, CFService ) {
         return {
          require: 'ngModel',
          restrict: 'A',
          link: function( scope, element, attrs, ctrl ) {
           ctrl.$validators.smartIsCodFisEnte = function( modelValue, viewValue ) {
            if( ( modelValue !== undefined ) && ( modelValue !== null ) ) {
             if( ( modelValue.length === 11 ) && CFService.checkPartitaIva( modelValue ) ) {
              return ResourceService.codiceFiscale( modelValue ).then( function( response ) {
            	  return $q.reject();
              }, function() {
               return false;
              } );
             }
             else
              return false;
            }
            else
             return true;
           };
          }
         };
        };

        function SmartCodfisc($filter, $log, CFService) {
            return {
                require: 'ngModel',
                restrict: 'A', // attributo
                link: function (scope, element, attrs, ctrl) {
                    var fromView = function (viewValue) {
                        try {
                            if (viewValue === undefined || viewValue === null || viewValue.length === 0) {
                                return undefined;
                            }
                            if (viewValue !== viewValue.toUpperCase()) {
                                viewValue = viewValue.toUpperCase();
                                ctrl.$setViewValue(viewValue);
                                ctrl.$render();

                            }
                            if (viewValue.length === 16 && CFService.checkCodFisc(viewValue)) return viewValue;
                            if (viewValue.length === 11 && CFService.checkPartitaIva(viewValue)) return viewValue;
                        } catch (err) {
                            $log.debug("SmartCodfisc: " + err);
                        }
                        return undefined;
                    };

                    var fromModel = function (modelValue) {
                        if (modelValue === undefined || modelValue === null || modelValue.length === 0) return modelValue;
                        return modelValue.toUpperCase();
                    };

                    //ctrl.$parsers.push(fromView);
                    ctrl.$formatters.push(fromModel);
                    ctrl.$validators.customSmartCodfisc = function (viewValue) {
                        if (viewValue === undefined || viewValue === null || viewValue.length === 0) {
                            return true;
                        }
                        if (viewValue.length === 16) return CFService.checkCodFisc(viewValue.toUpperCase());
                        if (viewValue.length === 11) return CFService.checkPartitaIva(viewValue);
                        return false;
                    };
                }
            };
        };

        function SmartDate($filter, $log) {

            return {
                require: 'ngModel',
                restrict: 'A',
                link: function (scope, element, attrs, ctrl) {

                    /*
                     * Imposto la Regex con il pattern ammesso dalla View gg/mm/aaaa
                     */
                    var DATE_REGEXP_VIEW = new RegExp("^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\\d\\d$");
                    $log.debug("DATE_REGEXP_VIEW: " + DATE_REGEXP_VIEW);

                    var fromView = function (viewValue) {
                        $log.debug("Called fromView! viewValue: " + viewValue);

                        if (DATE_REGEXP_VIEW.test(viewValue)) {
                            /*
                             * Se il valore inserito rispetta la Regex, divido i valori in giorno, mese e anno
                             */
                            var part = viewValue.split('/');
                            var day = parseInt(part[0], 10);
                            var month = parseInt(part[1], 10);
                            var year = parseInt(part[2], 10);

                            var dateToModel = undefined;

                            /*
                             * Creo la data in standard UTC
                             */
                            var date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));

                            if (date.getFullYear() === year && (date.getMonth() + 1) === month && date.getDate() === day) {
                                /*
                                 * Se la data e' valida, la restituisco in millisecondi
                                 */
                                dateToModel = date.getTime();
                            } else {
                                $log.debug("Invalid value from view: " + viewValue);
                            }

                            return dateToModel;
                        } else {
                            /*
                             * undefined from a parser means a parse error occurred.
                             * In that case, no $validators will run and the ngModel will be set to undefined
                             * unless ngModelOptions.allowInvalid is set to true.
                             * The parse error is stored in ngModel.$error.parse.
                             */
                            $log.debug("Invalid regex from view: " + viewValue);

                            /*
                             * Se la View e' undefined o stringa vuota, non invoco il parser error
                             */
                            if (viewValue === undefined || viewValue === "") {
                                return "";
                            } else {
                                return undefined;
                            }
                        }
                    };

                    var fromModel = function (modelValue) {
                        $log.debug("Called fromModel! modelValue: " + modelValue);

                        if (angular.isNumber(modelValue)) {
                            /*
                             * Converto il valore da millisecondi a una Stringa nel formato gg/mm/aaaa
                             */
                            var dateFromModel = new Date(modelValue);
                            var dateToView = $filter('date')(dateFromModel, 'dd/MM/yyyy');

                            return dateToView;

                        } else {
                            $log.debug("Invalid value from model: " + modelValue);
                            return undefined;
                        }
                    };

                    ctrl.$parsers.push(fromView);
                    ctrl.$formatters.push(fromModel);
                }
            };
        };

        function Capitalize(CONSTANTS) {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, modelCtrl) {
                    var capitalize = function (inputValue) {
                        if (inputValue == undefined) inputValue = '';

                        var capitalized = '';
                        var originalValue = '';
                        if (modelCtrl !== undefined) {
                            //valore non settato perch� non valido (lowercase), in tal caso lo rendiamo maiuscolo
                            var viewValue = modelCtrl.$viewValue;
                            if (modelCtrl.$invalid && inputValue === '' && viewValue !== undefined && viewValue !== '') {
                                //possibile validazione a false causata da regex che impone solo uppercase
                                originalValue = viewValue;
                                capitalized = viewValue.toUpperCase();
                            } else {
                                //valore gi� validato e correttamente impostato nel model
                                originalValue = inputValue;
                                capitalized = inputValue.toUpperCase();
                            }

                            //Confronto tra valore originale e valore uppercase, solo se discordanti aggiorniamo il model
                            capitalized = originalValue.toUpperCase();
                            if (capitalized !== originalValue) {
                                modelCtrl.$setViewValue(capitalized);
                                modelCtrl.$render();  //render fa scattare nuovamente la validazione
                            }
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize(scope[attrs.ngModel]);  // capitalize initial value
                }
            };
        };

        function Datepicker(CONSTANTS) {

            return {
                replace: true,
                restrict: 'E',
                scope: {
                    form: '=',
                    inputId: '@',
                    inputRequired: '=',
                    inputModel: '=',
                    label: '@',
                    calendario: '='
                },
                templateUrl: 'resources/html/includes/directives/datepicker.html' + CONSTANTS.URL_ARGS,
                /* 
                 * Definisco la configurazione del datepicker
                 */
                link: function (scope, element, attrs, ctrl) {

                    var _maxDate = new Date();

                    element.find('.input-group.date').datepicker({
                        format: 'dd/mm/yyyy',
                        maxViewMode: 2,
                        language: 'it',
                        orientation: 'auto right',
                        keyboardNavigation: false,
                        forceParse: false,
                        autoclose: true,
                        todayHighlight: true,
                        showOnFocus: false,
                        endDate: _maxDate,
                        templates: {
                            leftArrow: '<i class="fa fa-chevron-left"></i>',
                            rightArrow: '<i class="fa fa-chevron-right"></i>'
                        }
                    });
                }
            };
        };

        return inputDirectives;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/directives/input-directives.js
// module id = 38
// module chunks = 1